import { createFileRoute } from "@tanstack/react-router";
import BookmakerPredictions from "@/pages/BookmakerPredictions";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findBookmaker } from "@/lib/bookmakers";

export const Route = createFileRoute("/predictions/bookmaker/$slug")({
  head: ({ params }) => {
    const b = findBookmaker(params.slug);
    return {
      meta: [
        ...socialMeta({
        seo: { topics: ["footballPredictions"], entities: [readable(params.slug)] },
        title: b ? `${b.jackpotName} | Statlign` : `${readable(params.slug)} Coupon Analysis | Statlign`,
        description: b
          ? `${b.jackpotName} coupon analysis: market prices compared against Statlign model probabilities, with the reasoning for every selection.`
          : "Bookmaker coupon analysis comparing market prices against Statlign model probabilities.",
        ogType: "article",
      }),
      ],
    };
  },
  component: () => (
    <MainLayout>
      <BookmakerPredictions />
    </MainLayout>
  ),
});
